// Limits shared by Nautilus's roadmap host and embedded runtime.
// Dependency-free, usable in Node and in the browser.

// Legacy timeline horizons, used only when migrating boards without an end date.
export const ZOOM_DAYS = { weeks: 140, months: 280, quarters: 560 };
export const COLORS = ['violet', 'blue', 'teal', 'amber', 'coral', 'pink', 'slate'];
export const SIDEBAR_WIDTHS = [180, 200, 220, 240, 264, 288, 320];
export const LIMITS = { lanes: 24, items: 300, milestones: 40, history: 40, feedback: 300 };
export const HISTORY_LIMIT = LIMITS.history;

// Keep the historical board-size ceiling of 240 KiB. Boards must stay under SAVE_LIMIT, which
// leaves headroom for what the server adds on save (revision, timestamps, creator).
export const STORAGE_LIMIT = 240 * 1024;
export const SAVE_LIMIT = 232 * 1024;

const encoder = new TextEncoder();
// Stored size in bytes: Nautilus serializes the board as UTF-8 JSON.
export const boardBytes = (board) => encoder.encode(JSON.stringify(board ?? null)).length;
